import Container from 'components/common/Container'
import Button from 'components/common/Button'
import Dialog from 'components/custom/dialog/Dialog'
import DialogFooter from 'components/custom/dialog/DialogFooter'
import DialogHead from 'components/custom/dialog/DialogHead'
import { makeStyles } from '@mui/styles'
import PropTypes from 'prop-types'
import { useForm } from 'react-hook-form'
import Typography from 'components/common/Typography'
import { getColor } from 'theme/colors'
import { formatPrice } from 'utils/Utils'
import useSupplierCounter from 'common-hooks/buyer/counter/useSupplierCounter'
import { useParams } from 'react-router-dom'

const useStyles = makeStyles({
  dialogbody: {
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '18px 0',
  },
  selectField: {
    padding: '20px 30px 30px 30px',
    display: 'flex',
    gap: '18px 0',
    flexDirection: 'column',
    // overflow: 'hidden',
  },
  bodyInner: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px 0',
  },
})

export default function ConfirmationDialog({ open, onClose, currectPrice, counterPrice, counterId, mutate }) {
  const classes = useStyles()
  const params = useParams()
  const { setSupplierApprove } = useSupplierCounter()
  const { handleSubmit } = useForm()
  //   const options = countryOption?.map((item) => createOption(item, item))

  const onSubmit = () => {
    onClose()
    setSupplierApprove(
      {
        quote_id: params.id,
        counter_id: counterId,
      },
      mutate
    )
  }

  return (
    <>
      <Container>
        <Dialog open={open} width={'450px'}>
          <DialogHead title={'Confirmation'} onClose={onClose} />
          <form onSubmit={handleSubmit(onSubmit)}>
            <Container className={classes.dialogbody}>
              <Container>
                <Typography variant="title" color={'#13141B'} component="p">
                  Are you sure you want to accept this offer?
                </Typography>
                <Typography variant="paragraph1" color={getColor('grey-g25')}>
                  An order will be created once you have accepted the offer.
                </Typography>
              </Container>
              <Container className={classes.bodyInner}>
                <Typography variant="title" color={getColor('grey-g25')}>
                  Summary
                </Typography>
                <Container flex justify="space-between">
                  <Typography variant="body1" color={getColor('grey-g25')} component="p">
                    Buy Now Price
                  </Typography>
                  <Typography variant="body1" color={getColor('grey-g25')} component="p">
                    {formatPrice(currectPrice)}
                  </Typography>
                </Container>
                <Container flex justify="space-between">
                  <Typography variant="body1" color={getColor('grey-g25')} component="p">
                    Offer Price
                  </Typography>
                  <Typography variant="body1" color={getColor('grey-g25')} component="p">
                    {formatPrice(counterPrice)}
                  </Typography>
                </Container>
              </Container>
            </Container>
            <DialogFooter justify={'flex-end'}>
              <Container flex gap={'0 10px'}>
                <Button variant="secondary" border width={77} onClick={onClose}>
                  Cancel
                </Button>
                <Button type="submit">Accept Offer</Button>
              </Container>
            </DialogFooter>
          </form>
        </Dialog>
      </Container>
    </>
  )
}
ConfirmationDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  currectPrice: PropTypes.string,
  counterPrice: PropTypes.string,
  counterId: PropTypes.string,
  mutate: PropTypes.func,
}
